import { IsOptional } from 'class-validator';
import { BaseDto } from './base.dto';
import { NominalReportingDto } from './nominalReporting.dto';

export class StockCategoryDto extends BaseDto {
  name: string;
  photoURL?: string;
  startDate: Date;
  endDate?: Date;
  merchantId?: number;
  merchantGroupId?: number;
  parentId?: number;
  level?: number;
  stockTakeWeekly?: boolean;
  stockTakeMonthly?: boolean;

  @IsOptional()
  accountingName?: string;

  @IsOptional()
  nominalCodeId?: number;

  @IsOptional()
  nominalReportingId?: number;

  @IsOptional()
  nominalReporting?: NominalReportingDto;
}
